import { render, staticRenderFns } from "./of_tinymce.vue?vue&type=template&id=56ee311d&scoped=true&"
import script from "./of_tinymce.vue?vue&type=script&lang=js&"
export * from "./of_tinymce.vue?vue&type=script&lang=js&"
import style0 from "./of_tinymce.vue?vue&type=style&index=0&id=56ee311d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ee311d",
  null
  
)

export default component.exports